/**
 * Joins paths and prevents dupplicate seperators
 */
export function pathJoin(parts, separator = '/') {
	const replace = new RegExp(separator + '{1,}', 'g');
	return (
		parts
			.join(separator)
			.replace(replace, separator)
			// The regex above is removing dupplicate seperators, so we need to fix the protocol prefix for http(s)://
			.replace(/^(https?):\/{1,}/, '$1://')
	);
}
